module.exports = __webpack_public_path__ + "static/media/organization.11ebc659.svg";